import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';

var timeout1, timeout2, timeout3, timeout4;

@autobind
class Slider extends React.Component {
  state = {
    mouseHold:false,
    mouseOver:false,
    positionTop:182,
    initialAnimation: true,
  };

  componentDidMount(){
    var container = document.querySelector("#container2");
    window.addEventListener('mousedown', this.mouseDown);
    window.addEventListener('mousemove', this.handlePosition);
    window.addEventListener('mouseup', this.mouseUp);
    container.addEventListener('touchstart', this.mouseDown);
    container.addEventListener('touchmove', this.handlePosition);
    container.addEventListener('touchend', this.mouseUp);
    timeout1 = setTimeout(()=>this.setState({ positionTop:242}), 500);
    timeout2 = setTimeout(()=>this.setState({ positionTop:162}), 1400);
    timeout3 = setTimeout(()=>this.setState({ positionTop:202}), 2200);
    timeout4 = setTimeout(()=>this.setState({ initialAnimation:false}), 3000);
  }
  componentWillUnmount() {
    var container = document.querySelector("#container2");
    window.removeEventListener('mousedown', this.mouseDown);
    window.removeEventListener('mousemove', this.handlePosition);
    window.removeEventListener('mouseup', this.mouseUp);
    container.removeEventListener('touchstart', this.mouseDown);
    container.removeEventListener('touchmove', this.handlePosition);
    container.removeEventListener('touchend', this.mouseUp);
  }


  handlePosition(e){
    var rect;
    var y;
    if(this.state.mouseHold){
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
      clearTimeout(timeout4);
      if(e.clientY && this.state.mouseOver){
        rect = e.target.getBoundingClientRect();
        y = e.clientY - rect.top; 
        if(y<382 && y>20){
          this.setState({positionTop:y-20})
        }
      } else if(e.changedTouches) {
        e.preventDefault()
        rect = e.target.getBoundingClientRect();
        y = e.changedTouches[0].clientY - rect.top;
        if(y<382 && y>20){
          this.setState({positionTop:y-20})
        }
      }
    }
  }

  mouseDown(){
    this.setState({mouseHold:true,initialAnimation:false})
  }
  mouseUp(){
    this.setState({mouseHold:false})
  }
  mouseOver(){
    this.setState({mouseOver:true})
  }
  mouseOut(){
    this.setState({mouseOver:false})
  }

  render() {
    return (
      <div className={css(styles.wrapper)}>
        <div className={css(styles.innerWrapper)} onMouseOver={this.mouseOver} onMouseOut={this.mouseOut}>
          <img alt="minimaa showcase" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out"} : {transition:"0s"}} height={this.state.positionTop} className={css(styles.backgroundImg1)} src="../assets/showcaseMobileMinimaa.png"/>
          <img alt="instagram showcase" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out"} : {transition:"0s"}} height={364 - this.state.positionTop} className={css(styles.backgroundImg2)}  src="../assets/showcaseMobileInstagram.png"/>
           <img alt="minimaa slider" style={this.state.initialAnimation ? {transition:"0.8s ease-in-out",top:"calc("+this.state.positionTop+"px - 20px)"} : {transition:"0s",top:"calc("+this.state.positionTop+"px - 20px)"}} className={css(styles.slider)} src="../assets/sliderMobile.png"/>
          <div id="container2" className={css(styles.layer)} />
        </div>
        <div className={css(styles.text)}>Swipe up and down to change the view. </div>
      </div>
    );
  }
}
const styles = StyleSheet.create({
    wrapper:{
      margin:"0 auto",
      paddingLeft:128,
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"center",
      '@media (max-width: 1020px)': {
        paddingLeft:0,
      },
    },
    innerWrapper:{
      height:364,
      position:"relative",
      userSelect: "none",
      display:"flex",
      flexDirection:"column",
      justifyContent:"space-between",
      boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
      borderRadius:8,
    },
    backgroundImg1:{
      border:0,
      userSelect: "none",
      touchAction: "none",
      width:214,
      objectFit:"cover",
      objectPosition: "0% 0%",
      
    },
    backgroundImg2:{
      border:0,
      width:214,
      userSelect: "none",
      touchAction: "none",
      objectFit:"cover",
      objectPosition: "0% 100%",
      
      
    },
    layer:{
      position:"absolute",
      background:"transparent",
      zIndex:100,
      userSelect: "none",
      touchAction: "none",
      top:-30,
      bottom:-20,
      left:0,
      right:0,
      cursor:"pointer",
    },
    slider:{
      position:"absolute",
      left:-10,
      userSelect: "none",
      width:"calc(100% + 20px)",
    },
    text:{
      fontSize:12,
      userSelect: "none",
      textAlign:"center",
      marginTop:20,
      color:"#A3A3A3",
    },

});

export default Slider;